export enum EPageId {
    pdfEdit = 'pdf-edit',
    attaches = 'attaches',
    buy = 'buy',
    choice = 'choice',
    // tempexp_17127-next-line
    buyDisableAds = 'buy-disable-ads',
    buyMspPro = 'buy-msp-pro',
    discount = 'discount',
    favorites = 'favorites',
    feed = 'feed',
    gallery = 'gallery',
    home = 'home',
    notFound = 'not-found',
    personalDocuments = 'documents-type',
    personalDocumentsMain = 'documents-main',
    promocodes = 'promocodes',
    recommend = 'recommend',
    sharedAutodelete = 'shared-autodelete',
    sharedIndexed = 'shared-indexed',
    singleQuota = 'single-quota',
    singleQuotaIOS = 'quota-ios',
    singleQuotaAndroid = 'quota-and',
    singleQuotaPartner = 'quota-partner',
    singleQuotaTariffs = 'quota-tariffs',
    start = 'start',
    subscriptions = 'subscriptions',
    trashbin = 'trashbin',
    uploader = 'uploader',
    albums = 'albums',
    albumsCustom = 'albums-custom',
    albumsMain = 'albumsMain',
    duplicates = 'duplicates',
    sharedLinks = 'shared-links',
    sharedIncoming = 'shared-incoming',
    sharedIncomingPublic = 'shared-incoming-public',
    search = 'search',
    embedded = 'embedded',
    sharingAttach = 'sharing-attach',
    alldocuments = 'alldocuments',
    integration = 'integration',
    inlineIntegration = 'inline-integration',
    family = 'family',
    familyFolder = 'family-folders',
    familyPromo = 'family-promo',
    public = 'public',
    editor = 'editor',
    businessTemplatesRoot = 'business-templates-root',
    businessTemplatesCategory = 'business-templates-category',
    testEmbedded = 'test-embedded',
    vigbo = 'vigbo',
    vigboGallery = 'vigbo-gallery',
}
